import { buildOpendoorAddressFromGeo } from '@/dpp/components/opendoor/opendoor-address.js';

const FIBER_TECHNOLOGY_CODE = '50';
const CABLE_TECHNOLOGY_CODE = '40';

const TECHNOLOGY_LABELS = {
    [FIBER_TECHNOLOGY_CODE]: 'Fiber',
    [CABLE_TECHNOLOGY_CODE]: 'Cable',
};

export function buildCordlessIspAddressFromGeo(geo) {
    const address = buildOpendoorAddressFromGeo(geo);
    if (!address) {
        return null;
    }

    return {
        address: address.street1,
        city: address.city,
        state: address.state,
        zipcode: address.postalCode,
    };
}

export function getProviderTechnologyCode(provider) {
    if (!provider || typeof provider !== 'object') {
        return null;
    }

    if (provider.technologyCode != null) {
        return String(provider.technologyCode);
    }

    const offers = Array.isArray(provider.offers) ? provider.offers : Array.isArray(provider.offerings) ? provider.offerings : [];
    const firstOffer = offers[0];
    if (firstOffer && firstOffer.technologyCode != null) {
        return String(firstOffer.technologyCode);
    }

    return null;
}

export function getProviderMaxDownloadSpeed(provider) {
    if (!provider || typeof provider !== 'object') {
        return 0;
    }

    return provider.maxDownloadSpeed != null ? Number(provider.maxDownloadSpeed) || 0 : 0;
}

export function getProviderSpeedTechnologyLabel(provider) {
    return getProviderMaxDownloadSpeed(provider) > 1000 ? 'Fiber' : 'Cable';
}

export function getTechnologyLabel(code) {
    if (code == null || code === '') {
        return '';
    }
    return TECHNOLOGY_LABELS[String(code)] || '';
}

export function getProviderName(provider) {
    if (!provider || typeof provider !== 'object') {
        return '';
    }
    return provider.name || provider.providerName || provider.brandName || provider.companyName || '';
}

export function getProviderKey(provider, index = 0) {
    return `${provider?.id || 'provider'}-${index}`;
}

function mapIspProvider(provider) {
    const adOffer = provider.adOffer || {};
    return {
        id: provider.id,
        name: provider.name || '',
        technology: getProviderSpeedTechnologyLabel(provider),
        link: adOffer.clickUrl || '',
        cta: adOffer.cta || 'See details',
    };
}

export function selectIspProviders(providers) {
    const eligible = (Array.isArray(providers) ? providers : []).filter((provider) => provider && provider.adOffer);
    if (!eligible.length) {
        return [];
    }

    return eligible
        .slice()
        .sort((a, b) => getProviderMaxDownloadSpeed(b) - getProviderMaxDownloadSpeed(a))
        .map(mapIspProvider);
}

function normalizeTrackerType(type) {
    return String(type || 'image').toLowerCase();
}

export function appendImpressionTracker(container, url, type) {
    if (!container || !url) {
        return;
    }

    const trackerType = normalizeTrackerType(type);

    if (trackerType === 'iframe') {
        const iframe = document.createElement('iframe');
        iframe.src = url;
        iframe.width = '0';
        iframe.height = '0';
        iframe.style.display = 'none';
        iframe.setAttribute('aria-hidden', 'true');
        container.appendChild(iframe);
        return;
    }

    if (trackerType === 'javascript' || trackerType === 'script') {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        container.appendChild(script);
        return;
    }

    const img = document.createElement('img');
    img.src = url;
    img.width = 1;
    img.height = 1;
    img.style.display = 'none';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    container.appendChild(img);
}

export function renderImpressionTrackers(container, providers) {
    if (!container) {
        return;
    }

    container.innerHTML = '';
    (Array.isArray(providers) ? providers : []).forEach((provider) => {
        const adOffer = provider && provider.adOffer;
        if (!adOffer) {
            return;
        }

        appendImpressionTracker(container, adOffer.impressionTrackingUrl, adOffer.impressionTrackingUrlPrimaryType);
        appendImpressionTracker(container, adOffer.impressionTrackingUrlSecondary, adOffer.impressionTrackingUrlSecondaryType);
    });
}
